import { z } from "zod";

const BrowseTreatmentsSummarySchema = z.object({
  query: z.any(),
});

export default BrowseTreatmentsSummarySchema;
